class TutorialslandingController {
  constructor($state) {
    this.name = 'Tutorials';
    this.state = $state;
  }

}

TutorialslandingController.$inject = ['$state'];

export default TutorialslandingController;



// WEBPACK FOOTER //
// ./client/app/components/landingpage/tutorialslanding/tutorialslanding.controller.js